
import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider as ReduxProvider } from 'react-redux'
import { persistor, store } from './store/configureStore';
import App from './app/App';

ReactDOM.render(
  <ReduxProvider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
    >
      <App />
    </PersistGate>
  </ReduxProvider>,
  document.getElementById('root'),
);
